module.exports = __webpack_public_path__ + "img/icon-speed-4.d668b1ab.svg";